import { useEffect, useState } from 'react';

/**
 * 👁 live viewer count next to the clock. Each tab heartbeats an anonymous
 * random id every 30s; the server counts ids seen in the last ~75s.
 */
export function Viewers() {
  const [count, setCount] = useState<number | null>(null);

  useEffect(() => {
    let stopped = false;
    const id =
      sessionStorage.getItem('chronos-eye-id') ||
      (() => {
        const v =
          typeof crypto !== 'undefined' && 'randomUUID' in crypto
            ? crypto.randomUUID()
            : `${Date.now()}-${Math.random().toString(36).slice(2)}`;
        sessionStorage.setItem('chronos-eye-id', v);
        return v;
      })();

    const beat = async () => {
      try {
        const r = await fetch(`/api/presence?id=${encodeURIComponent(id)}`);
        if (!r.ok) return;
        const d = await r.json();
        if (!stopped && typeof d.viewers === 'number') setCount(d.viewers);
      } catch {
        /* transient — next beat retries */
      }
    };
    beat();
    const interval = setInterval(beat, 30000);
    return () => {
      stopped = true;
      clearInterval(interval);
    };
  }, []);

  if (count === null) return null;

  return (
    <span className="viewers" title={`${count} viewer${count === 1 ? '' : 's'} on the dashboard right now`}>
      👁 {count}
    </span>
  );
}
